module.exports = __webpack_public_path__ + "static/img/up-f.63ccc6a1.png";